import { Grid } from '@mui/material';
import { ChartCardContainer } from '../ChartCardContainer';
import { SplineChartWithHeader } from '../../shared/SplineChartWithHeader';
import { RslReport } from '../../../api/schema';
import { reportsToSeriesData } from '../../../../../utils/reports-to-series-data';
import { ComponentProps } from 'react';
import { formatters } from '@utils/formattersV2';

const buildChartProps = (
  props: ChartCardsProps
): ComponentProps<typeof SplineChartWithHeader>[] => [
  {
    title: 'Incremental Visit Lift',
    'data-testid': 'rsl-incremental-visit-lift-chart',
    differenceType: 'lift',
    confidenceLevel:
      props.selectedReport.incrementalVisitLiftConfidenceLevel ?? undefined,
    data: reportsToSeriesData({
      reports: props.reports,
      valueGetter: r => r.incrementalVisitLift,
    }),
    formatter: value => formatters.lift(value),
    yAxisLabelFormatter: value => formatters.percentage(value, { decimals: 0 }),
  },
  {
    title: 'Incremental Visit',
    'data-testid': 'rsl-incremental-visit-chart',
    differenceType: 'standard',
    data: reportsToSeriesData({
      reports: props.reports,
      valueGetter: r => r.projectedIncrementalVisits,
    }),
    formatter: value => formatters.number(value, { full: true }),
    yAxisLabelFormatter: value => formatters.number(value, { full: true }),
  },
  {
    title: 'Impressions',
    'data-testid': 'rsl-visit-impressions-chart',
    differenceType: 'standard',
    data: reportsToSeriesData({
      reports: props.reports,
      valueGetter: r => r.impressions,
    }),
    formatter: value => formatters.number(value, { full: true }),
    yAxisLabelFormatter: value => formatters.number(value, { full: true }),
  },
  {
    title: 'Unique Users',
    'data-testid': 'rsl-visit-unique-users-chart',
    differenceType: 'standard',
    data: reportsToSeriesData({
      reports: props.reports,
      valueGetter: r => r.uniqueUsers,
    }),
    formatter: value => formatters.number(value, { full: true }),
    yAxisLabelFormatter: value => formatters.number(value, { full: true }),
  },
];

type Report = Pick<
  RslReport,
  | 'reportDate'
  | 'incrementalVisitLift'
  | 'incrementalVisitLiftConfidenceLevel'
  | 'impressions'
  | 'uniqueUsers'
  | 'projectedIncrementalVisits'
>;

type ChartCardsProps = {
  selectedReport: Report;
  reports: Report[];
};

export const ChartCards = (props: ChartCardsProps) => {
  return (
    <Grid container spacing="1rem">
      {buildChartProps(props).map(chartProps => (
        <ChartCardContainer key={chartProps.title}>
          <SplineChartWithHeader {...chartProps} />
        </ChartCardContainer>
      ))}
    </Grid>
  );
};
